import { ParametrosAutenticacao } from './keycloak.interface'
import i18n from '@/typescript/servicos/i18n/i18n.servico'
import config from '@/config'
import { obterUrlBaseGestao } from 'src/utils/criadoras/criadoras'

export const definirLocaleKeycloak = (): string => {
  try {
    const locale = i18n.locale as string
    const opcoesPortugues = ['pt-BR', 'pt']
    const opcoesIngles = ['en', 'en-US']
    const opcoesEspanhol = ['es', 'es-CO']

    if (opcoesPortugues.includes(locale)) {
      return 'pt-BR'
    } else if (opcoesIngles.includes(locale)) {
      return 'en'
    } else if (opcoesEspanhol.includes(locale)) {
      return 'es'
    } else {
      return 'pt-BR'
    }
  } catch {
    return 'pt-BR'
  }
}


export const obterParametrosAutenticacaoKeycloak = (): ParametrosAutenticacao => {
  const urlParams = new URLSearchParams(window.location.search)

  const sessionState = urlParams.get('session_state')
  const code = urlParams.get('code')
  const realm = urlParams.get('realm')

  return {
    sessionState,
    code,
    realm
  }
}

export const possuiParametrosAutenticacaoKeycloak = (): boolean => {
  const parametros = obterParametrosAutenticacaoKeycloak()

  return Object.values(parametros).every(Boolean)
}

export const construirUrlDeRedirecionamentoKeycloak = (realm: string): string => {
  return `${window.location.origin}${window.location.pathname}?realm=${realm}`
}

export const construirUrlDeRenovacaoToken = (realm: string): string => {
  return `${process.env.VUE_APP_KEYCLOAK_BASE_URL}/realms/${realm}/protocol/openid-connect/token`
}

export const construirUrlDeLogout = (realm: string): string => {
  const linguagem = definirLocaleKeycloak()

  const keycloakLogoutUrl = new URL(config.keycloakBaseUrl);
  keycloakLogoutUrl.pathname = `/realms/${realm}/protocol/openid-connect/logout`;
  keycloakLogoutUrl.searchParams.set('client_id', 'pontotel');
  keycloakLogoutUrl.searchParams.set('ui_locales', linguagem);

  // Redirect para ao clicar em sair no keycloak, mandar de volta para a tela de login do gestao
  const urlRetorno = new URL(obterUrlBaseGestao())
  const parametrosDaTelaDeLogin = new URLSearchParams({
    ui_locales: linguagem,
    autologin: 'false'
  })
  urlRetorno.hash = `/cognito/login?${parametrosDaTelaDeLogin.toString()}`
  keycloakLogoutUrl.searchParams.set(
    'post_logout_redirect_uri',
    urlRetorno.toString()
  );

  return keycloakLogoutUrl.toString();
}
